import React from 'react';
import Card from './Card';

const projects = [
  {
    title: "TO-DO App with express.js",
    url: "/",
    image: "/assets/CardImages/ToDoCard.png",  
    description: "A task management web app with a custom-built API and database. It features a login system with verification. The front end was made with Nunjucks, and the back end with Node.js, Knex.js, and Express.js.",
    tags: [
      { name: "Node.js", color: "bg-green-500" },
      { name: "Express.js", color: "bg-gray-600" },
      { name: "Database", color: "bg-blue-500" }
    ]
  },
  {
    title: "Mini game: BonkTheDog",
    url: "/",
    image: "/assets/CardImages/betterbonk.png",  
    description: "One of my first game projects — a simple clicker game where you earn points by clicking on the dog. Built with HTML, CSS, and JavaScript, and includes a step-by-step tutorial on how it was made.",
    tags: [
      { name: "JavaScript", color: "bg-yellow-500" },
      { name: "HTML", color: "bg-orange-500" },
      { name: "CSS", color: "bg-blue-400" }
    ]
  },
  {
    title: "studioClean Website",
    url: "/",
    image: "/assets/CardImages/studioclean.png",  
    description: "A fictional company website designed to showcase clean, responsive front-end development. Built with Nunjucks, HTML, CSS, and JavaScript.",
    tags: [
      { name: "Nunjucks", color: "bg-green-600" },
      { name: "Frontend", color: "bg-purple-500" }
    ]
  },
  {
    title: "Javelin's Reach",
    url: "/",
    image: "/assets/CardImages/GodotJavelin.png",
    description: "A 2D tactical game in development, built with Godot. Inspired by games like StoneShard, it features units with unique abilities that battle each other using their strengths.",
    tags: [
      { name: "Godot", color: "bg-blue-600" },
      { name: "Game Dev", color: "bg-red-500" }
    ]
  },
  {
    title: "Belgian Girl",
    url: "/",
    image: "/assets/CardImages/thebelgiangirl.png",
    description: "A real client project built with CraftCMS. The site allows the owner to manage content independently. It includes a booking system where clients can reserve rooms, and the owner can manage all bookings from a custom dashboard.",
    tags: [
      { name: "CraftCMS", color: "bg-orange-600" },
      { name: "Real  Client Project", color: "bg-green-500" }
    ]
  },
  {
    title: "MeaFolio",
    image: "/assets/CardImages/pgm4.png",
    description: "A fictional social media platform built with Laravel and Blade, where users can upload and comment on each other's art. Users can edit their profiles and follow other artists.",
    tags: [
      { name: "Laravel", color: "bg-red-600" },
      { name: "PHP", color: "bg-indigo-500" }
    ]
  },
  {
    title: "ArtHub",
    image: "/assets/CardImages/pgm5.png",
    description: "A portfolio platform built with Symfony, allowing users to easily create and share their own social portfolio. Portfolios can be exported as PDFs or shared via link for use on social media.",
    tags: [
      { name: "Symfony", color: "bg-gray-700" },
      { name: "PDF Export", color: "bg-yellow-600" }
    ]
  },
  {
    title: "BeleefBerlare",
    url: "/",
    image: "/assets/CardImages/BB.png",
    description: "A Drupal-based website built for the municipality of Berlare during my internship. I worked on both the back end and front end, developing custom modules and themes. One custom module integrated with the UiTinVlaanderen API to fetch and store event data in the database.",
    tags: [
      { name: "Drupal", color: "bg-blue-700" },
      { name: "API Integration", color: "bg-green-600" },
      { name: "Internship", color: "bg-purple-600" }
    ]
  },
  {
    title: "L'art de la deco",
    url: "https://lartdeladeco.net/",
    image: "/assets/CardImages/artdeladeco.png",
    description: "A real client project for an interior decoration business. Built with React. The site features a gallery of past projects, a contact form, and a blog section where the owner can share interior design tips and trends.",
    tags: [
      { name: "React", color: "bg-cyan-500" },
      { name: "Real Client Project", color: "bg-green-500" }
    ]
  }
];

function CardSection() {
  return (
    <div className="p-8 fade-in pt-[6rem]">
      <h2 className="text-3xl font-bold text-center mb-8 text-white">Projects</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {projects.map(project => {
          const hasUrl = Boolean(project.url);
          const isExternal = hasUrl && /^https?:\/\//.test(project.url);
          if (hasUrl) {
            return (
              <a
                key={project.title}
                href={project.url}
                className="block"
                target={isExternal ? "_blank" : undefined}
                rel={isExternal ? "noopener noreferrer" : undefined}
              >
                <Card {...project} />
              </a>
            );
          }
          return (
            <div key={project.title}>
              <Card {...project} />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default CardSection;